import styles from './List.css'
import * as actGratuity from 'actions/library/gratuity'
import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import {isDirty} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'

class List extends React.Component {
  render () {
    let {gratuities, gratuityDetail} = this.props

    return (gratuities.length > 0 &&
      <div className={styles['wrapper']}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th className={styles.name}>Name</th>
              <th className={styles.amount}>Amount</th>
            </tr>
          </thead>
        </table>
        <div className={styles['table-content-wrapper']}>
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            <table className={`${styles['table-content']}`}>
              <tbody>
                {gratuities.length === 0 && <tr>
                  <td colSpan='5' style={{textAlign: 'center'}}>No data to display</td>
                </tr>}
                {gratuities.length > 0 && gratuities.map((gratuity) => {
                  return (<tr className={`${(gratuityDetail && gratuity.id === gratuityDetail.id) ? styles.selected : ''}`}
                    onClick={() => this._onClickRow(gratuity)}>
                    <td className={styles.name}>{gratuity.name}</td>
                    <td className={styles.amount}>{gratuity.amount}</td>
                  </tr>)
                })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>)
  }

  _onClickRow = (gratuity) => {
    const {isDirtyGratuity} = this.props
    if (isDirtyGratuity) {
      this.props.dispatch(askConfirmAction(actGratuity.onClickRow(gratuity)))
    } else {
      this.props.dispatch(actGratuity.onClickRow(gratuity))
    }
  };

  _onReachBottom = () => {
    let {dispatch, currentPage, gratuities} = this.props
    dispatch(actGratuity.gratuitiesRequest({page: currentPage + 1}, gratuities))
  };

  _hasMore = () => {
    let {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }
}

function mapStateToProps (state) {
  let {gratuities, gratuityDetail, currentPage, totalPage} = state.library.gratuity
  return {
    gratuities,
    gratuityDetail,
    currentPage,
    totalPage,
    isDirtyGratuity: isDirty('gratuity')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  gratuities: React.PropTypes.array,
  gratuityDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Library/Gratuity/List/List.js